import React from 'react';
import { defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { getMessage } from '../../reducers/i18n';
import ActionableIcon from '../buttons/ActionableIcon';
import LinkGenerator from './PinterestLinkGenerator';

defineMessages({
    defaultPinterest: {
        id: 'DEFAULT_PINTEREST_SHARE_DESCRIPTION',
        defaultMessage: 'www.schnoffle.de | "Näh Dir Dein Designerstück!" ist unser Motto. Dafür bekommst Du Designer-Schnitt und Stoff im Näh-Paket. Das Besondere: Du gestaltest die Stoffe selbst. Alles wird nach Deinen Vorgaben hier in Deutschland hergestellt. Slow Fashion. Sozial und nachhaltig. Alles für perfekte Unikate.',
    },
});

const SharePinterest = ({ shareTarget, media, description, buttonText, buttonLabel, onHover, iconProps, handleClick }) => {
    const Icon = styled(ActionableIcon)`
        &.schnoffle-pinterest-button {
            width: 100%;
            height: ${props => props.theme.space[10]};
            flex-direction: row;
            
            & > svg {
              margin-right: 1rem;
            }
        }
    `;

    const ShareLink = LinkGenerator(shareTarget, media, description);

    const StyledLink = styled.a`

        color: inherit;
        text-decoration: none;

        &:focus,
        &:hover {
          text-decoration: none;
        }

        &:active {
          color: inherit;
        }

        &:visited {
          color: inherit;
        }

    `;

    return (
        <StyledLink
            onClick={handleClick} href={ShareLink} target='_blank'
            aria-label='Share on Pinterest'
        >
            <Icon
                text={buttonText || null} label={buttonLabel || null}
                onHover={onHover || null} iconProps={iconProps}
                className='schnoffle-pinterest-button'
            />
        </StyledLink>
    );
};

const makeMapStateToProps = (initialState, initialOwnProps) => {
    const message = getMessage(initialState, initialOwnProps.messageId ||
        'DEFAULT_PINTEREST_SHARE_DESCRIPTION');
    const mapStateToProps = () => ({
        description: message,
        ...initialOwnProps,
    });
    return mapStateToProps;
};

export default connect(makeMapStateToProps)(SharePinterest);




// WEBPACK FOOTER //
// ./src/components/sharing/PinterestIcon.js